module.exports = __webpack_public_path__ + "img/debit.cccac225.svg";